<template>
    <div>
        <div class="popup_st01">
            <div :class="wrapClass">
                <div class="title">
                    <span class="ict_btn red">{{ safetyInfo.safetyCategory }}</span>
                    <span class="t01">{{ dongName }} ({{ safetyInfo.safetyType }})</span>
                </div>

                <div class="pop_table03">
                    <table>
                        <caption>재난리스트</caption>
                        <colgroup>
                            <col style="width: 20%;" />
                        </colgroup>
                        <tbody>
                        <!-- <tr>
                            <th>진행상태</th>
                            <td><span class="t_red">{{ curState }}</span></td>
                        </tr> -->
                        <tr>
                            <th>발생일시</th>
                            <td><span class="t_red">{{ safetyInfo.registerTime | formatDate('yyyy.MM.dd HH:mm') }}</span></td>
                        </tr>
                        <tr>
                            <th>발생위치</th>
                            <td><span>{{ shortAddr }}</span></td>
                        </tr>
                        <tr>
                            <th>처리기관</th>
                            <td><span>{{ safetyInfo.controlStation }}</span></td>
                        </tr>
                        <!-- <tr v-if="hasRoleFirstHead">
                            <th>피해상황</th>
                            <td><span>{{ safetyInfo.safetyDescript }}</span></td>
                        </tr> -->
                        </tbody>
                    </table>
                </div>

                <div class="time_line">
                    <!-- 재난 -->
                    <ul class="t7" v-if="safetyInfo.safetyCategoryCd === '0'">
                        <li :class="[{on: curStateCd >= 0}, {ing: curStateCd == 0}]">
                            <p>출동지령</p>
                            <span class="time real" v-if="historyMap['S_0']">{{ historyMap['S_0'] ? historyMap['S_0'].recDateHm : '' }}</span>
                        </li>
                        <li :class="[{on: curStateCd >= 10}, {ing: curStateCd == 10}]">
                            <p>출동중</p>
                            <span class="time real" v-if="historyMap['S_10']">{{ historyMap['S_10'] ? historyMap['S_10'].dispatchHm : '' }}</span>
                        </li>
                        <li :class="[{on: curStateCd >= 20}, {ing: curStateCd == 20}]">
                            <p>현장도착</p>
                            <span class="time real" v-if="historyMap['S_20']">{{ historyMap['S_20'] ? historyMap['S_20'].arrivalHm : '' }}</span>
                        </li>
                        <li :class="[{on: curStateCd >= 30}, {ing: curStateCd == 30}]">
                            <p>활동개시</p>
                            <span class="time real" v-if="historyMap['S_30']">{{ historyMap['S_30'] ? historyMap['S_30'].recDateHm : '' }}</span>
                        </li>
                        <li :class="[{on: curStateCd >= 50}, {ing: curStateCd == 50}]">
                            <p>조치완료</p>
                            <span class="time real" v-if="historyMap['S_50']">{{ historyMap['S_50'] ? historyMap['S_50'].recDateHm : '' }}</span>
                        </li>
                        <li :class="[{on: curStateCd >= 60}, {ing: curStateCd == 60}]">
                            <p>귀소중</p>
                            <span class="time real" v-if="historyMap['S_60']">{{ historyMap['S_60'] ? historyMap['S_60'].recDateHm : '' }}</span>
                        </li>
                        <li :class="[{on: curStateCd >= 100}, {ing: curStateCd == 100}]">
                            <p>상황종료</p>
                            <span class="time real" v-if="historyMap['S_100']">{{ historyMap['S_100'] ? historyMap['S_100'].recDateHm : '' }}</span>
                        </li>
                    </ul>

                    <!-- 화재 -->
                    <ul class="t7" v-if="safetyInfo.safetyCategoryCd === '1'">
                        <li :class="[{on: curStateCd >= 0}, {ing: curStateCd == 0}]">
                            <p>출동지령</p>
                            <span class="time real" v-if="historyMap['S_0']">{{ historyMap['S_0'] ? historyMap['S_0'].recDateHm : '' }}</span>
                        </li>
                        <li :class="[{on: curStateCd >= 10}, {ing: curStateCd == 10}]">
                            <p>출동중</p>
                            <span class="time real" v-if="historyMap['S_10']">{{ historyMap['S_10'] ? historyMap['S_10'].dispatchHm : '' }}</span>
                        </li>
                        <li :class="[{on: curStateCd >= 20}, {ing: curStateCd == 20}]">
                            <p>현장도착</p>
                            <span class="time real" v-if="historyMap['S_20']">{{ historyMap['S_20'] ? historyMap['S_20'].arrivalHm : '' }}</span>
                        </li>
                        <li :class="[{on: curStateCd >= 30}, {ing: curStateCd == 30}]">
                            <p>활동개시</p>
                            <span class="time real" v-if="historyMap['S_30']">{{ historyMap['S_30'] ? historyMap['S_30'].recDateHm : '' }}</span>
                        </li>
                        <li :class="[{on: curStateCd >= 40}, {ing: curStateCd == 40}]">
                            <p>초진</p>
                            <span class="time real" v-if="historyMap['S_40']">{{ historyMap['S_40'] ? historyMap['S_40'].recDateHm : '' }}</span>
                        </li>
                        <li :class="[{on: curStateCd >= 50}, {ing: curStateCd == 50}]">
                            <p>완진</p>
                            <span class="time real" v-if="historyMap['S_50']">{{ historyMap['S_50'] ? historyMap['S_50'].recDateHm : '' }}</span>
                        </li>
                        <li :class="[{on: curStateCd >= 100}, {ing: curStateCd == 100}]">
                            <p>상황종료</p>
                            <span class="time real" v-if="historyMap['S_100']">{{ historyMap['S_100'] ? historyMap['S_100'].recDateHm : '' }}</span>
                        </li>
                    </ul>

                    <!-- 구조 -->
                    <ul class="t7" v-if="safetyInfo.safetyCategoryCd === '2'">
                        <li :class="[{on: curStateCd >= 0}, {ing: curStateCd == 0}]">
                            <p>출동지령</p>
                            <span class="time real" v-if="historyMap['S_0']">{{ historyMap['S_0'] ? historyMap['S_0'].recDateHm : '' }}</span>
                        </li>
                        <li :class="[{on: curStateCd >= 10}, {ing: curStateCd == 10}]">
                            <p>출동중</p>
                            <span class="time real" v-if="historyMap['S_10']">{{ historyMap['S_10'] ? historyMap['S_10'].dispatchHm : '' }}</span>
                        </li>
                        <li :class="[{on: curStateCd >= 20}, {ing: curStateCd == 20}]">
                            <p>현장도착</p>
                            <span class="time real" v-if="historyMap['S_20']">{{ historyMap['S_20'] ? historyMap['S_20'].arrivalHm : '' }}</span>
                        </li>
                        <li :class="[{on: curStateCd >= 30}, {ing: curStateCd == 30}]">
                            <p>활동개시</p>
                            <span class="time real" v-if="historyMap['S_30']">{{ historyMap['S_30'] ? historyMap['S_30'].recDateHm : '' }}</span>
                        </li>
                        <li :class="[{on: curStateCd >= 40}, {ing: curStateCd == 40}]">
                            <p>구조중</p>
                            <span class="time real" v-if="historyMap['S_40']">{{ historyMap['S_40'] ? historyMap['S_40'].recDateHm : '' }}</span>
                        </li>
                        <li :class="[{on: curStateCd >= 50}, {ing: curStateCd == 50}]">
                            <p>구조완료</p>
                            <span class="time real" v-if="historyMap['S_50']">{{ historyMap['S_50'] ? historyMap['S_50'].recDateHm : '' }}</span>
                        </li>
                        <li :class="[{on: curStateCd >= 100}, {ing: curStateCd == 100}]">
                            <p>상황종료</p>
                            <span class="time real" v-if="historyMap['S_100']">{{ historyMap['S_100'] ? historyMap['S_100'].recDateHm : '' }}</span>
                        </li>
                    </ul>

                    <!-- 구급 -->
                    <ul class="t8" v-if="safetyInfo.safetyCategoryCd === '3'">
                        <li :class="[{on: curStateCd >= 0}, {ing: curStateCd == 0}]">
                            <p>출동지령</p>
                            <span class="time real" v-if="historyMap['S_0']">{{ historyMap['S_0'] ? historyMap['S_0'].recDateHm : '' }}</span>
                        </li>
                        <li :class="[{on: curStateCd >= 10}, {ing: curStateCd == 10}]">
                            <p>출동중</p>
                            <span class="time real" v-if="historyMap['S_10']">{{ historyMap['S_10'] ? historyMap['S_10'].dispatchHm : '' }}</span>
                        </li>
                        <li :class="[{on: curStateCd >= 20}, {ing: curStateCd == 20}]">
                            <p>현장도착</p>
                            <span class="time real" v-if="historyMap['S_20']">{{ historyMap['S_20'] ? historyMap['S_20'].arrivalHm : '' }}</span>
                        </li>
                        <li :class="[{on: curStateCd >= 30}, {ing: curStateCd == 30}]">
                            <p>활동개시</p>
                            <span class="time real" v-if="historyMap['S_30']">{{ historyMap['S_30'] ? historyMap['S_30'].recDateHm : '' }}</span>
                        </li>
                        <li :class="[{on: curStateCd >= 40}, {ing: curStateCd == 40}]" v-if="isTransfer">
                            <p>이송중</p>
                            <span class="time real" v-if="historyMap['S_40']">{{ historyMap['S_40'] ? historyMap['S_40'].recDateHm : '' }}</span>
                        </li>
                        <li :class="[{on: curStateCd >= 40}, {ing: curStateCd == 40}]" v-if="!isTransfer">
                            <p>미이송</p>
                            <span class="time real" v-if="historyMap['S_40']">{{ historyMap['S_40'] ? historyMap['S_40'].recDateHm : '' }}</span>
                        </li>
                        <li :class="[{on: curStateCd >= 50}, {ing: curStateCd == 50}]">
                            <p>병원도착</p>
                            <span class="time real" v-if="historyMap['S_50']">{{ historyMap['S_50'] ? historyMap['S_50'].recDateHm : '' }}</span>
                        </li>
                        <li :class="[{on: curStateCd >= 60}, {ing: curStateCd == 60}]">
                            <p>귀소중</p>
                            <span class="time real" v-if="historyMap['S_60']">{{ historyMap['S_60'] ? historyMap['S_60'].recDateHm : '' }}</span>
                        </li>
                        <li :class="[{on: curStateCd >= 100}, {ing: curStateCd == 100}]">
                            <p>상황종료</p>
                            <span class="time real" v-if="historyMap['S_100']">{{ historyMap['S_100'] ? historyMap['S_100'].recDateHm : '' }}</span>
                        </li>
                    </ul>

                    <!-- 기타 -->
                    <ul class="t7" v-if="safetyInfo.safetyCategoryCd === '4'">
                        <li :class="[{on: curStateCd >= 0}, {ing: curStateCd == 0}]">
                            <p>출동지령</p>
                            <span class="time real" v-if="historyMap['S_0']">{{ historyMap['S_0'] ? historyMap['S_0'].recDateHm : '' }}</span>
                        </li>
                        <li :class="[{on: curStateCd >= 10}, {ing: curStateCd == 10}]">
                            <p>출동중</p>
                            <span class="time real" v-if="historyMap['S_10']">{{ historyMap['S_10'] ? historyMap['S_10'].dispatchHm : '' }}</span>
                        </li>
                        <li :class="[{on: curStateCd >= 20}, {ing: curStateCd == 20}]">
                            <p>현장도착</p>
                            <span class="time real" v-if="historyMap['S_20']">{{ historyMap['S_20'] ? historyMap['S_20'].arrivalHm : '' }}</span>
                        </li>
                        <li :class="[{on: curStateCd >= 30}, {ing: curStateCd == 30}]">
                            <p>활동개시</p>
                            <span class="time real" v-if="historyMap['S_30']">{{ historyMap['S_30'] ? historyMap['S_30'].recDateHm : '' }}</span>
                        </li>
                        <li :class="[{on: curStateCd >= 50}, {ing: curStateCd == 50}]">
                            <p>조치완료</p>
                            <span class="time real" v-if="historyMap['S_50']">{{ historyMap['S_50'] ? historyMap['S_50'].recDateHm : '' }}</span>
                        </li>
                        <li :class="[{on: curStateCd >= 60}, {ing: curStateCd == 60}]">
                            <p>귀소중</p>
                            <span class="time real" v-if="historyMap['S_60']">{{ historyMap['S_60'] ? historyMap['S_60'].recDateHm : '' }}</span>
                        </li>
                        <li :class="[{on: curStateCd >= 100}, {ing: curStateCd == 100}]">
                            <p>상황종료</p>
                            <span class="time real" v-if="historyMap['S_100']">{{ historyMap['S_100'] ? historyMap['S_100'].recDateHm : '' }}</span>
                        </li>
                    </ul>
                </div>
                <div class="pop_bt_close2"><a href="javascript: void(0);" class="self-close-btn">닫기</a></div>
            </div>
        </div>
    </div>
</template>

<script>
import { $_WC } from '@/confs/common.const.js';
import commonConstMixin from "@/stores/common.const.mixin.js";
import realtimeApi from "@/apis/realtime.api.js";

export default {
    name: "SafetyInfoWin",
    data() {
        return {
            win: window,
            safetyInfo: {},
            historyMap: {},
            isTransfer: false,
            curState: '',
            curStateCd: -1,
        };
    },
    props: {
        wrapClass: {
            type: String,
            default: 'popup_wrap',
        }
    },
    computed: {
        dongName() {
            let safetyInfo = this.safetyInfo;
            let addressArr = ['', ''];
            if(typeof safetyInfo !== 'undefined' && typeof safetyInfo.address !== 'undefined') {
                addressArr = safetyInfo.address.split(' ');
            }

            return addressArr[1].split('(')[0];
        },
        shortAddr() {
            let safetyInfo = this.safetyInfo;
            let addressArr = ['', ''];

            if(typeof safetyInfo !== 'undefined' && typeof safetyInfo.address !== 'undefined') {
                addressArr = this.safetyInfo.address.split(' ');
            }

            return addressArr[0] + ' ' + addressArr[1].split('(')[0];
        },
    },
    updated() {
        this.$emit('loaded-safety-info', this.$el.innerHTML);
    },
    methods: {
        setRegisterNo(registerNo) {
            realtimeApi.fetchSafety(registerNo)
                .then(res => {
                    let safety = res.data.data;
                    let historyList = safety.safetyHistoryList;
                    let historyMap = {};
                    let lastHistory = {};

                    if(typeof historyList !== $_WC.UNDEF) {
                        for(let i = 0; i < historyList.length; i++) {
                            let historyStatuCd = historyList[i]['processStateCd'];
                            historyMap['S_' + historyStatuCd] = historyList[i];

                            if(historyList[i].processState === '이송중') {
                                this.isTransfer = true;
                            }

                            if(i === (historyList.length - 1)) {
                                lastHistory = historyList[i];
                            }
                        }
                    }

                    this.historyMap = historyMap;
                    this.curState = '' || lastHistory['processState'];
                    this.curStateCd = '' || lastHistory['processStateCd'];
                    this.safetyInfo = safety;
                });
        }
    },
    mixins: [commonConstMixin],
}
</script>
<style>
.popup_wrap .time_line .time.real{position: absolute; bottom:95%; left: 15%;}
.simple_popup_wrap .time_line .time.real{position: absolute; bottom:95%; left: 15%;}
</style>
